import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const partnerApi = axios.create({
  baseURL: `${BASE}/api`,
  withCredentials: true,
});

const PartnerAuthCtx = createContext(null);
export const usePartnerAuth = () => useContext(PartnerAuthCtx);

export function PartnerAuthProvider({ children }) {
  const [partner, setPartner] = useState(null);
  const [loading, setLoading] = useState(true);

  const check = useCallback(async () => {
    try {
      const r = await partnerApi.get("/partner/me");
      setPartner(r.data);
    } catch {
      setPartner(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { check(); }, [check]);

  const login = async (email, password) => {
    const r = await partnerApi.post("/partner/login", { email, password });
    setPartner(r.data.partner);
    await check();
  };
  const logout = async () => {
    try { await partnerApi.post("/partner/logout"); } catch {}
    setPartner(null);
    window.location.href = "/partner/login";
  };

  return (
    <PartnerAuthCtx.Provider value={{ partner, loading, login, logout }}>
      {children}
    </PartnerAuthCtx.Provider>
  );
}
